<form-layout
    [showSave]="canSave"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">

    <institution-form [form]="institutionDataForm"></institution-form>
</form-layout>
